import {isNumeric} from "rxjs/internal-compatibility";
import {LovValueSummary} from "../../modules/common/lov/lov-value/api/model/lovValueSummary.model";

export class StringUtils {

    public static isEmpty(value: string): boolean {
        return !value || value.length == 0 || value.trim() === '';
    }

    public static isNotEmpty(value: string): boolean {
        return !this.isEmpty(value);
    }

    public static toNumeric(value: string): number {
        if (value && isNumeric(value)) {
            // console.logByType"value to numeric : ", value);
            return +value;
        }
        return null;
    }

    public static unescapeHtml(escapedHtml: string): string {
        if (!escapedHtml) {
            return undefined;
        }
        return escapedHtml.replace(new RegExp('&lt;', 'g'), '<')
            .replace(new RegExp('&gt;', 'g'), '>')
            .replace(new RegExp('&quot;', 'g'), '"')
            .replace(new RegExp('&agrave;', 'g'), 'à');
    }


    public static leftPad(value: string, size: number, character: string): string {
        if (value.length >= size) {
            return value;
        }
        return this.leftPad(character + value, size, character);
    }

    public static removeWhitespaces(value: string): string {
        return value?.replace(/\s/g, "");
    }


    public static join(separator: string, ...values): string {
        let chain = '';
        if (!values) {
            return chain;
        }
        values.forEach(value => chain = this.chainValue(chain, value, separator));
        return chain;
    }

    public static chainValue(chain: string, value: string, separator: string): string {
        if (chain.length > 0) {
            chain += separator;
        }
        chain += value;
        return chain;
    }

    public static joinLovValues(lovValues: LovValueSummary[]): string {
        lovValues = lovValues ? lovValues : [];
        return lovValues.map(value => value.label).join(', ');
    }

    public static capitalize(value: string): string {
        if (this.isEmpty(value)) {
            return value;
        }
        return value[0].toUpperCase() + value.slice(1)
    }

    public static removeHtml(value: string): string {
        const div = document.createElement('div');
        div.innerHTML = value;
        return div.textContent || div.innerText || '';
    }
}
